import React, { useState } from 'react';
import { Tabs } from '@otp/ui';
import { FoldersCard } from './folders';
import { BookmarksCard } from './bookmarks';
import { useTranslation } from 'react-i18next';

export const ResourcesTabsCard = () => {
  const { t } = useTranslation();
  const [tab, setTab] = useState('folders');
  const tabs = [
    { label: t('resources.file-explorer.title'), value: 'folders' },
    { label: t('resources.bookmarks.title'), value: 'bookmarks' },
  ];

  return (
    <div className="h-full flex flex-col w-full">
      <Tabs
        tabs={tabs}
        value={tab}
        onChange={(_, value) => setTab(value)}
        className="mb-4"
      />
      <div className="flex-1">
        {tab === 'folders' && <FoldersCard />}
        {tab === 'bookmarks' && <BookmarksCard />}
      </div>
    </div>
  );
};

export default ResourcesTabsCard;
